import { useEffect, useState } from "react";

import RegisterContext from "../context/RegisterContext";
const initialValue = {
  firstName: "",
  lastName: "",
  email: "",
  authProviderCode: "COGNITO",
  phoneNumber: null,
  mobilePhoneNumber: null,
  whatsAppPhoneNumber: "",
  isProfessional: false,
  isLegalAreaProfessional: false,
  isEconomicsAreaProfessional: false,
  isOtherAreaProfessional: false,
  isStudent: false,
  isLegalAreaStudent: false,
  isEconomicsAreaStudent: false,
  isOtherAreaStudent: false,
  enableMailNotification: true,
  enableWhatsappNotification: true,
};

const RegisterProvider = ({ children }) => {
  const [step, setStep] = useState(1);
  const [registerData, setRegisterData] = useState(initialValue);
  const [isEditing, setIsEditing] = useState(false);

  const nextStep = () => {
    setStep((prevStep) => prevStep + 1);
  };
  const prevStep = () => {
    setStep((prevStep) => prevStep - 1);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const newValue =
      value === "true" ? true : value === "false" ? false : value;

    if (name === "isProfessional" && newValue === false) {
      setRegisterData({
        ...registerData,
        isProfessional: false,
        isLegalAreaProfessional: false,
        isEconomicsAreaProfessional: false,
        isOtherAreaProfessional: false,
      });
    } else if (name === "isStudent" && newValue === false) {
      setRegisterData({
        ...registerData,
        isStudent: false,
        isLegalAreaStudent: false,
        isEconomicsAreaStudent: false,
        isOtherAreaStudent: false,
      });
    } else {
      setRegisterData({
        ...registerData,
        [name]: newValue,
      });
    }
  };

  const isButtonDisabled =
    // (!registerData.isProfessional && !registerData.isStudent) || // Ni profesional ni estudiante
    (registerData.isProfessional && // Es profesional pero no ha selecciono nungun area
      !registerData.isLegalAreaProfessional &&
      !registerData.isEconomicsAreaProfessional &&
      !registerData.isOtherAreaProfessional) ||
    (registerData.isStudent && // Es estudiante pero no selecciono ningun area
      !registerData.isLegalAreaStudent &&
      !registerData.isEconomicsAreaStudent &&
      !registerData.isOtherAreaStudent);

  function capitalizeFirstLetter(text) {
    if (!text) return "";
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  return (
    <RegisterContext.Provider
      value={{
        step,
        nextStep,
        prevStep,
        setRegisterData,
        registerData,
        handleInputChange,
        isButtonDisabled,
        isEditing,
        setIsEditing,
        capitalizeFirstLetter,
      }}
    >
      {children}
    </RegisterContext.Provider>
  );
};

export default RegisterProvider;
